(function () {
  const content = document.querySelector(".js-article-content");
  if (!content) return;

  const buttonTexts = [
    "商品を見る",
    "ViewProduct",
    "查看商品"
  ];

  const links = content.querySelectorAll("a");

  links.forEach((link) => {
    const text = (link.textContent || "")
      .replace(/\s+/g, "")
      .trim();

    if (!buttonTexts.includes(text)) return;

    link.classList.add("button", "purchase-button");
  });
})();